<template>
  <v-card class="pa-2">
    <div class="d-flex justify-space-between flex-wrap">
      <v-row dense class="ma-0" align="center" style>
        <v-col cols="12" sm="5" style="min-width: 222px">
          <label class="label">Nome</label>
          <v-text-field
            v-model="filterListFolderWithDoc.name"
            class="primary-input"
            outlined
            hide-details="auto"
            placeholder="Pesquisar por Nome"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="2" style="margin-top: auto">
          <v-btn class="primary-button ma-1 mb-4" depressed @click="loadData">
            Filtrar
          </v-btn>
        </v-col>
      </v-row>
      <div style="margin-top: 18px; align-content: center">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              depressed
              class="primary-button ma-1 mb-4"
              color="secondary"
              v-bind="attrs"
              v-on="on"
              v-if="user.mainType == 0 || user.mainType == 1"
            >
              Novo item
            </v-btn>
          </template>
          <v-list nav dense>
            <v-list-item-group active-class="info--text text--accent-2">
              <v-list-item
                v-for="(item, index) in addMenuItems"
                :key="index"
                @click="item.action"
                width="100%"
              >
                <v-list-item-icon class="mr-2">
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-menu>
      </div>
    </div>
    <div v-if="downloadList.length > 0" class="d-flex justify-end mt-4">
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            dark
            class="mr-2 hidden-sm-and-down primary-button ma-1"
            v-bind="attrs"
            v-on="on"
            depressed
          >
            {{ $t('Selecionados') }}
          </v-btn>
        </template>
        <v-list nav dense>
          <v-list-item width="100%" @click="getZip">
            <v-list-item-icon class="mr-2">
              <v-icon>mdi-download</v-icon>
            </v-list-item-icon>
            <v-list-item-title>
              {{ $t('Baixar Selecionados') }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item width="100%" @click="deleteSelectedItens">
            <v-list-item-icon class="mr-2">
              <v-icon>mdi-delete</v-icon>
            </v-list-item-icon>
            <v-list-item-title>
              {{ $t('Excluir Selecionados') }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
    <div class="mt-6 topper-espansion">
      <p class="ma-0 topper-espansion-title">Identificação</p>
      <p class="ma-0 topper-espansion-title">Ações</p>
    </div>

    <v-expansion-panels v-model="panel">
      <DragDiv
        :list="listFolderWithDoc"
        group="items"
        ghost-class="ghost"
        animation="200"
        style="width: 100%"
        draggable=".my-list-items"
        @change="ChangeOrder"
      >
        <v-expansion-panel
          v-for="(item, i) in listFolderWithDoc"
          :key="i"
          :readonly="item.isDocument"
          class="my-list-items"
        >
          <v-expansion-panel-header
            :hide-actions="item.isDocument"
            :style="`${item.isDocument ? 'cursor: default' : ''}`"
          >
            <div
              v-if="item.isDocument"
              class="d-flex justify-center"
              style="max-width: 20px; margin-top: -6px"
            >
              <v-checkbox
                class="mr-1"
                dense
                small
                v-model="item.selected"
                hide-details
                @click="addToDownloadList(item)"
              ></v-checkbox>
            </div>
            <span
              v-if="item.isDocument"
              style="margin-bottom: -4px; margin-left: 6px"
            >
              <v-icon class="pr-2" style="margin-top: -3px">
                mdi-file-document-outline
              </v-icon>
              <span class="font-weight-medium pt-2">{{ item.name }}</span>
            </span>
            <span v-else>
              <v-icon class="pr-2" style="margin-top: -3px">
                mdi-folder-outline
              </v-icon>
              <span class="font-weight-medium pt-2">{{ item.name }}</span>
            </span>
            <div
              :style="`display: flex; justify-content: flex-end; ${
                item.isDocument ? 'margin-right: 32px' : 'margin-right: 12px'
              }`"
            >
              <span>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      class="ma-1"
                      small
                      depressed
                      color="primary"
                      v-if="user.mainType == 0 || user.mainType == 1"
                      @click.stop="
                        item.isDocument
                          ? editDocument(item)
                          : updateFolder(item)
                      "
                    >
                      <v-icon small color="#f5f5f5">mdi-pencil-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Editar</span>
                </v-tooltip>

                <v-menu v-if="!item.isDocument" offset-y>
                  <template v-slot:activator="{ on }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on: tooltipOn }">
                        <v-btn
                          class="ma-1"
                          small
                          depressed
                          color="primary"
                          v-if="user.mainType == 0 || user.mainType == 1"
                          v-on="{ ...on, ...tooltipOn }"
                        >
                          <v-icon small color="#f5f5f5">mdi-plus</v-icon>
                        </v-btn>
                      </template>
                      <span>Adicionar</span>
                    </v-tooltip>
                  </template>
                  <v-list nav dense>
                    <v-list-item-group active-class="info--text text--accent-2">
                      <v-list-item
                        v-for="(actionItem, index) in addTableItems"
                        :key="index"
                        @click.stop="actionItem.action(item)"
                        width="100%"
                      >
                        <v-list-item-icon class="mr-2">
                          <v-icon>{{ actionItem.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>{{
                          actionItem.title
                        }}</v-list-item-title>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-menu>

                <v-tooltip v-if="item.isDocument" bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      class="ma-1"
                      small
                      depressed
                      color="primary"
                      @click.stop="getFile(item)"
                    >
                      <v-icon small color="#f5f5f5">mdi-open-in-new</v-icon>
                    </v-btn>
                  </template>
                  <span>Abrir documento</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      class="ma-1"
                      small
                      depressed
                      color="#ff4f64"
                      v-if="user.mainType == 0 || user.mainType == 1"
                      @click.stop="
                        item.isDocument
                          ? deleteDocument(item)
                          : deleteFolder(item)
                      "
                    >
                      <v-icon small color="#f5f5f5"
                        >mdi-trash-can-outline</v-icon
                      >
                    </v-btn>
                  </template>
                  <span>Excluir</span>
                </v-tooltip>
              </span>
            </div>
          </v-expansion-panel-header>

          <v-expansion-panel-content>
            <PopsFolderClinic
              v-if="!item.isDocument"
              :folder="item"
              @get-file="getFile"
              @delete-document="deleteDocument"
              @delete-folder="deleteFolder"
              @add-to-download-list="addToDownloadList"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </DragDiv>
    </v-expansion-panels>

    <div class="pagination">
      <div class="item-pagination block-one">
        <v-menu bottom offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              class="btn"
              depressed
              color="#C0C0C0"
              small
            >
              qtd: {{ pageSize }}
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(size, i) in sizes"
              :key="i"
              @click="pageSize = size"
            >
              <v-list-item-title>{{ size }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <div class="registros" v-if="totalItensOnPage">
          <span> 1 - {{ totalItensOnPage }} de {{ totalItems }} </span> <br />
        </div>
      </div>

      <div class="item-pagination block-two">
        <v-pagination
          class="pagination-item"
          v-model="page"
          :length="totalPages"
          :total-visible="3"
        ></v-pagination>
      </div>
    </div>

    <v-dialog v-if="modal" v-model="modal" max-width="500px">
      <PopsManageDocumentClinic
        :documentId="selectedDocument.id"
        :parentFolderId="selectedFolderId"
        :engType="0"
        @close="modal = false"
        @success="reloadData"
        :key="dialogKey"
      />
    </v-dialog>

    <v-dialog v-if="folderModal" v-model="folderModal" max-width="500px">
      <PopsManageFolderClinic
        :folderId="selectedFolderId"
        :parentFolderId="parentFolderId"
        :engType="0"
        @close="folderModal = false"
        @success="reloadData"
        :key="folderDialogKey"
      />
    </v-dialog>

    <v-dialog v-model="deleteDialog" max-width="300px">
      <div class="text-center">
        <v-sheet
          class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
          color="blue-grey darken-3"
          dark
        >
          <div class="grey--text text--lighten-1 text-body-2 mb-4">
            Tem certeza de que deseja enviar este arquivo para a lixeira?
          </div>

          <v-btn class="ma-1" color="grey" text @click="deleteDialog = false"
            >Cancelar</v-btn
          >
          <v-btn class="ma-1" color="error" text @click="confirmDelete()"
            >Excluir</v-btn
          >
        </v-sheet>
      </div>
    </v-dialog>

    <v-dialog v-model="deleteFolderDialog" max-width="300px">
      <div class="text-center">
        <v-sheet
          class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
          color="blue-grey darken-3"
          dark
        >
          <div class="grey--text text--lighten-1 text-body-2 mb-4">
            Tem certeza de que deseja excluir esse video?
          </div>

          <v-btn
            class="ma-1"
            color="grey"
            text
            @click="deleteFolderDialog = false"
          >
            Cancelar
          </v-btn>
          <v-btn class="ma-1" color="error" text @click="confirmDeleteFolder()">
            Excluir
          </v-btn>
        </v-sheet>
      </div>
    </v-dialog>
  </v-card>
</template>

<script>
import ApiService from '../../../../services/ApiService'
import moment from 'moment'
import PopsManageDocumentClinic from './PopsManageDocumentClinic.vue'
import PopsManageFolderClinic from './PopsManageFolderClinic.vue'
import PopsFolderClinic from './popsComponentClinic/PopsFolderClinic.vue'

export default {
  name: 'PopsDocument',

  components: {
    PopsManageDocumentClinic,
    PopsManageFolderClinic,
    PopsFolderClinic,
  },

  data() {
    return {
      showSelectedOptions: false,
      selectedFolderId: null,
      selectedDocument: {},
      trashModal: false,
      trashModalKey: false,
      user: {},
      page: 1,
      totalPages: null,
      totalItensOnPage: 0,
      totalItems: 0,
      pageSize: 10,
      sizes: [10, 30, 90, 180],
      downloadList: [],
      menuStartDate: false,
      menuEndDate: false,
      startDate: null,
      endDate: null,
      documents: [],
      apiService: new ApiService(),
      loading: false,
      headerProps: {
        sortByText: 'Ordenar por',
      },
      filter: {
        page: 1,
        pageSize: 10,
        name: '',
      },
      modal: false,
      deleteDialog: false,
      valid: false,
      editMode: false,
      newDocument: {
        name: '',
        file: null,
        institutionId: null,
        expireDate: null,
        fileBase64: '',
      },
      menuExpireDate: false,
      dialogKey: false,
      headerCheckbox: false,
      tab: 0,
      folderModal: false,
      folderDialogKey: Date.now() + 1,
      folder: {
        name: '',
        institutionId: '',
        folderId: null,
      },
      folders: [],
      deleteFolderDialog: false,
      selectedFolder: null,
      editFolderMode: false,
      expanded: [],
      secondExpanded: [],
      thirdExpanded: [],
      singleExpand: true,
      moveFolderModal: false,
      moveFolderDialogKey: Date.now() + 2,
      selectedFolderToMove: null,
      combinedItems: [],
      loadingCombinedTable: false,
      combinedPage: 1,
      combinedPageSize: 10,
      allFolders: [],
      availableFoldersToMove: [],
      listFolderWithDoc: [],
      filterListFolderWithDoc: {
        institutionId: null,
        name: '',
        page: 1,
        pageSize: 10,
      },
      specificFolder: null,
      allFoldersWithoutRemove: [],
      panel: null,
      addMenuItems: [
        {
          title: 'Adicionar Documento',
          icon: 'mdi-file-document-plus-outline',
          action: this.openModal,
        },
        {
          title: 'Adicionar Pasta',
          icon: 'mdi-folder-plus-outline',
          action: this.openFolderModal,
        },
      ],
      addTableItems: [
        {
          title: 'Adicionar Documento',
          icon: 'mdi-file-document-plus-outline',
          action: this.openAddDocModal,
        },
        {
          title: 'Adicionar Pasta',
          icon: 'mdi-folder-plus-outline',
          action: this.openAddFolderModal,
        },
      ],
      addToFolderModal: false,
      addToFolderDialogKey: Date.now() + 3,
      addToDoMode: false,
      allFoldersWithoutOwn: [],
      allFoldersWithoutRemoveAndOwn: [],
      parentFolderId: null,
      commonAreafilesSize: 0,
    }
  },

  async created() {
    this.user = JSON.parse(localStorage.getItem('user'))
    this.loadData()
  },

  watch: {
    pageSize() {
      this.filterListFolderWithDoc.pageSize = this.pageSize
      this.filterListFolderWithDoc.page = 1
      this.getListFolderWithDoc()
    },

    page() {
      this.filterListFolderWithDoc.page = this.page
      this.getListFolderWithDoc()
    },
  },

  methods: {
    reloadData() {
      this.loadData()
      this.modal = false
      this.folderModal = false
    },

    toggleSelectedOptions() {
      this.showSelectedOptions = !this.showSelectedOptions
    },

    async ChangeOrder(event) {
      if (event.moved) {
        const findItem = event.moved.element
        findItem.order = event.moved.newIndex

        if (findItem.filePath) await this.updateDocOrder(findItem)
        else await this.updateFolderOrder(findItem)
      }
    },

    async updateDocOrder(item) {
      const model = {
        entityId: item.id,
        order: item.order,
      }
      this.apiService.post('PopDocument/change-order', model)
    },

    async updateFolderOrder(item) {
      const model = {
        entityId: item.id,
        order: item.order,
      }
      this.apiService.post('PopDocumentFolder/change-order', model)
    },

    async loadData() {
      const myPanel = this.panel
      await this.getAllFolders()
      await this.getListFolderWithDoc()
      this.panel = myPanel
    },

    parseDate(date) {
      if (!date) return null
      const [day, month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    addToDownloadList(file) {
      if (file.selected) {
        this.downloadList.push(file)
      } else {
        this.downloadList = this.downloadList.filter((x) => x.id != file.id)
      }

      this.headerCheckbox = this.documents.every((doc) => doc.selected)
    },

    getFile(document) {
      if (document.filePath) {
        if (document.filePath.includes('.pdf')) {
          const basePath = document.filePath.includes('equipacarefix.blob.core')
            ? document.filePath
            : process.env.VUE_APP_BASE_URL +
              document.filePath.replace('wwwroot/', '')

          const encodedUrl = encodeURIComponent(basePath)

          // Agora com /pdfjs/web/viewer.html
          const viewerPath = `/pdfjs/web/viewer.html?file=${encodedUrl}`
          window.open(viewerPath, '_blank')
        } else {
          const url = document.filePath
          window.open(url)
        }
      } else {
        this.getDocument(document)
      }
    },

    formatDate(date) {
      return date ? moment(date).format('DD/MM/yyyy') : 'Sem registros'
    },

    saveCreatedAt(date) {
      this.startDate = this.formatDate(this.filter.createdAt)
      this.$refs.menuStartDate.save(date)
    },

    saveExpireDate(date) {
      this.endDate = this.formatDate(this.filter.expireDate)
      this.$refs.menuEndDate.save(date)
    },

    openModal() {
      this.selectedDocument = {}
      this.dialogKey = !this.dialogKey
      this.modal = true
    },

    openAddDocModal(item) {
      this.selectedDocument = {}
      this.selectedFolderId = item ? item.id : null
      this.dialogKey = !this.dialogKey
      this.modal = true
    },

    closeModal() {
      this.modal = false
      this.dialogKey = !this.dialogKey
    },

    async addDocument() {
      if (this.$refs.form.validate()) {
        if (!this.newDocument.file) {
          this.$toast.error('Nenhum arquivo selecionado!')
          return
        }

        this.loading = true
        const reader = new FileReader()
        reader.readAsDataURL(this.newDocument.file)

        reader.onload = () => {
          const extension = this.newDocument.file.name.split('.').pop()
          const base64String = reader.result

          const documentData = {
            identification: this.newDocument.name,
            folderId: this.newDocument.folderId,
            filePath: base64String,
            extension: extension,
            engType: engClinic,
            institutionId: institutionId,
            expireDate: this.newDocument.expireDate,
          }

          this.apiService
            .post('PopDocument/add', documentData)
            .then(() => {
              this.$toast.success('Documento adicionado com sucesso!')
              this.closeModal()
              this.loadData()
              this.loading = false
            })
            .catch((error) => {
              this.$toast.error('Erro ao adicionar o documento.')
              this.loading = false
            })
        }

        reader.onerror = () => {
          this.$toast.error('Erro ao ler o arquivo.')
          this.loading = false
        }
      }
    },

    async updateDocument() {
      if (this.$refs.form.validate()) {
        this.loading = true

        const documentData = {
          id: this.selectedDocument.id,
          identification: this.newDocument.name,
          folderId: this.newDocument.folderId,
          expireDate: this.newDocument.expireDate,
        }

        if (this.newDocument.file) {
          const reader = new FileReader()
          reader.readAsDataURL(this.newDocument.file)

          reader.onload = () => {
            const extension = this.newDocument.file.name.split('.').pop()
            documentData.filePath = reader.result
            documentData.extension = extension

            this.sendUpdateRequest(documentData)
          }

          reader.onerror = () => {
            this.$toast.error('Erro ao ler o arquivo.')
            this.loading = false
          }
        } else {
          documentData.filePath = this.selectedDocument.filePath
          documentData.extension = this.selectedDocument.extension
          this.sendUpdateRequest(documentData)
        }
      }
    },

    sendUpdateRequest(documentData) {
      this.apiService
        .put('PopDocument/edit', documentData)
        .then(() => {
          this.$toast.success('Documento atualizado com sucesso!')
          this.closeModal()
          this.loadData()
          this.loading = false
        })
        .catch((error) => {
          this.$toast.error('Erro ao atualizar o documento.')
          this.loading = false
        })
    },

    editDocument(item) {
      this.dialogKey = !this.dialogKey
      this.selectedDocument = { ...item }
      this.modal = true
    },

    deleteDocument(item) {
      this.selectedDocument = item
      this.deleteDialog = true
    },

    confirmDelete() {
      const selectedDocumentId = this.selectedDocument.id
      this.apiService
        .delete(`PopDocument/delete/${selectedDocumentId}`)
        .then(() => {
          this.loadData()
          this.$toast.success('Documento excluído com sucesso!')
          this.deleteDialog = false
        })
        .catch(() => {
          this.$toast.error('Erro ao excluir o documento.')
          this.deleteDialog = false
        })
    },

    // async deleteSelectedItens() {
    //   const ids = this.downloadList.map((file) => file.id)

    //   if (!ids.length) {
    //     this.$toast.error('Nenhum item selecionado para exclusão.')
    //     return
    //   }

    //   await this.apiService
    //     .delete('CommonAreaDocument/delete-selected-files', ids)
    //     .then((response) => {
    //       if (response.statusCode === 200) {
    //         this.downloadList = []
    //         this.showSelectedOptions = false
    //         return this.loadData().then(() => {
    //           this.$toast.success('Itens selecionados excluídos com sucesso!')
    //         })
    //       } else {
    //         this.$toast.error('Erro ao excluir os itens selecionados.')
    //       }
    //     })
    //     .catch((error) => {
    //       console.error('Erro ao excluir os itens selecionados:', error)
    //       this.$toast.error('Erro ao excluir os itens selecionados.')
    //     })
    // },

    async getAllFolders(itemId) {
      try {
        const response = await this.apiService.get(
          `PopDocumentFolder/list-clinic`
        )
        this.allFolders = [...response.content]
        this.allFoldersWithoutRemove = [...response.content]
        if (itemId) {
          this.allFoldersWithoutOwn = [...response.content].filter(
            (folder) => folder.id !== itemId
          )
          this.allFoldersWithoutRemoveAndOwn = [...response.content].filter(
            (folder) => folder.id !== itemId
          )
        }
        this.addOptionRemoveToAllFolders()
      } catch (error) {
        console.log(error)
        console.error('Erro ao carregar pastas.')
      }
    },

    addOptionRemoveToAllFolders() {
      this.allFolders.unshift({
        id: null,
        name: 'Remover das pastas',
      })
      this.allFoldersWithoutOwn.unshift({
        id: null,
        name: 'Remover das pastas',
      })
    },

    async getFolders() {
      try {
        const response = await this.apiService.get(
          'PopDocumentFolder/list-clinic',
          this.filter
        )
        this.folders = response.content.data
      } catch (error) {
        console.log(error)
        console.error('Erro ao carregar pastas.')
      }
    },

    addFolder() {
      if (this.$refs.folderForm.validate()) {
        this.apiService.post('PopDocumentFolder/add', this.folder).then(() => {
          this.$toast.success('Pasta criada com sucesso!')
          this.folderModal = false
          this.addToFolderModal = false
          this.loadData()
        })
      }
    },

    openFolderModal() {
      this.folderDialogKey = !this.folderDialogKey
      this.selectedFolderId = null
      this.folderModal = true
    },

    openAddFolderModal(item) {
      this.folderDialogKey = !this.folderDialogKey
      this.selectedFolderId = null
      this.parentFolderId = item ? item.id : null
      this.folderModal = true
    },

    updateFolder(item) {
      this.folderDialogKey = !this.folderDialogKey
      this.selectedFolderId = item.id
      this.parentFolderId = item.folderId
      this.editFolderMode = true
      this.folderModal = true
    },

    deleteFolder(item) {
      this.selectedFolder = item
      this.deleteFolderDialog = true
    },

    confirmDeleteFolder() {
      const selectedFolderId = this.selectedFolder.id
      this.apiService
        .delete(`PopDocumentFolder/delete/${selectedFolderId}`)
        .then(() => {
          this.deleteFolderDialog = false
          this.$toast.success('Pasta excluída com sucesso!')
          this.loadData()
        })
    },

    async getListFolderWithDoc() {
      try {
        this.filterListFolderWithDoc.page = this.page
        this.filterListFolderWithDoc.pageSize = this.pageSize

        const response = await this.apiService.get(
          `PopDocumentFolder/list-with-doc-clinic`,
          this.filterListFolderWithDoc
        )
        this.panel = null
        this.listFolderWithDoc = response.content.data
        this.totalPages = response.content.pager.totalPages
        this.totalItems = response.content.pager.totalItems
        this.totalItensOnPage = response.content.data.length
      } catch (error) {
        console.error('Erro ao carregar a lista de documentos.', error)
      }
    },
  },
}
</script>

<style scoped>
.ghost {
  opacity: 0.5;
}

.topper-espansion {
  background-color: #4c6d97;
  display: flex;
  min-height: 48px;
  border-radius: 4px;
  justify-content: space-between;
  align-items: center;
  padding: 0 60px 0 28px;
}
.topper-espansion-title {
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  line-height: 14px;
  overflow-wrap: break-word;
  text-align: center;
}
.v-expansion-panel-header {
  padding-block: 8px !important;
}
.v-sheet-style {
  color: var(--primary-button-font-color) !important;
  height: var(--default-button-height) !important;
  background: var(--primary-button-color) !important;
  border-radius: var(--default-button-border-radius) !important;
  font-family: var(--default-font-family) !important;
  font-weight: var(--default-font-weight) !important;
  font-size: var(--default-font-size) !important;
  line-height: var(--default-line-height) !important;
  letter-spacing: var(--default-letter-spacing) !important;
  text-transform: none;
}
</style>
